import { jsxs, jsx } from 'react/jsx-runtime';
import { useSize } from '@flex-design-system/fx-utils/hooks';
import { useMergedCSS } from '@flex-design-system/stitches-react';
import { useComposedRefs } from '@radix-ui/react-compose-refs';
import { AnimatePresence, motion } from 'framer-motion';
import { forwardRef } from 'react';
import { slideFrom } from '../../animations.mjs';
import Title from '../title/Title.mjs';
import { useModalContext } from './context.mjs';
import { scrolledToolbarStyle, StyledToolbar } from './styled.mjs';

const DEFAULT_TRIGGER_TRANSITION_Y = 28;
const Toolbar = forwardRef((props, ref) => {
  const {
    title,
    unscrolledTitle,
    children,
    css: cssFromProps,
    leftSlot,
    ...toolbarProps
  } = props;
  const {
    scrollPos,
    title: modalTitle,
    onToolbarChange,
    contentElement
  } = useModalContext("ModalToolbar");
  const mainContentSize = useSize(contentElement);
  const composedRef = useComposedRefs(ref, onToolbarChange);
  const titleAreaOffset = modalTitle?.offsetHeight ?? DEFAULT_TRIGGER_TRANSITION_Y;
  const renderToolbarTitle = scrollPos > titleAreaOffset;
  const css = useMergedCSS(
    cssFromProps,
    renderToolbarTitle ? scrolledToolbarStyle : void 0,
    { width: mainContentSize?.width ?? "100%" }
  );
  return /* @__PURE__ */ jsxs(StyledToolbar, { ref: composedRef, css, ...toolbarProps, children: [
    leftSlot,
    /* @__PURE__ */ jsx(AnimatePresence, { exitBeforeEnter: true, children: renderToolbarTitle ? /* @__PURE__ */ jsx(motion.div, { ...slideFrom("bottom", 2), children: title }, "scrolled") : unscrolledTitle ? /* @__PURE__ */ jsx(motion.div, { ...slideFrom("top", 2), children: unscrolledTitle }, "unscrolled") : null }),
    children
  ] });
});
const ToolbarTitle = (props) => {
  const { size = "xsmall", ...titleProps } = props;
  return /* @__PURE__ */ jsx(Title, { size, ...titleProps });
};

export { ToolbarTitle, Toolbar as default };
//# sourceMappingURL=Toolbar.mjs.map
